import { Component, Inject } from '@angular/core';
import { AuthService } from '@app/core/auth.service';
import { Restangular } from 'ngx-restangular';
import { untilDestroyed } from 'src/app/core/until-destroyed';
import { Main } from '../core/main.service';
import { EkubService } from './ekub.service';
// import { Router } from '@angular/router';

@Component({
  selector: 'cp-awards',
  templateUrl: './awards.component.html',
})

export class AwardsComponent {
  filter: string;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  awards: any[];
  credentials: any;

  constructor(@Inject(Restangular) public Restangular, private mainService: Main, private api: EkubService, private authService: AuthService) {
    this.filter = '&type=';
    this.itemsPerPage = 10;
    this.totalItems = 0;
    this.currentPage = 1;
    this.getAwardFilter('');
    this.credentials = authService.credentials;

  }

  getAwardFilter(filter: any) {
    this.filter = filter;
    this.getAwards();
  }

  getAwards() {
    let j = this.itemsPerPage * this.currentPage - this.itemsPerPage;
    this.api.getAwards(this.currentPage, this.filter).subscribe((resp: any) => {
      debugger;
      this.awards = resp.data;
      for (let i = 0; i < this.awards.length; i++) {
        this.awards[i].no = j + 1;
        j++;
      }
      this.totalItems = resp.meta.pagination.total;
      this.itemsPerPage = resp.meta.pagination.per_page;
    }, (err) => {
      this.mainService.toast({ title: 'Error', body: err.statusText, type: 'danger' });

    });
  }

  pageChanged(event: any) {
    event = event;
    this.currentPage = this.currentPage;
    this.getAwards();
  }

  changeStatus(award: any, status: any) {
    debugger;
    console.log(this.credentials);
    if (award.status == 'received' && this.credentials.type != 'system_admin') {
      this.mainService.toast({ title: 'Error', body: "You cannot change a received award status", type: 'danger' });
      return;
    }
    if (!award.winner) {
      if (status == "sold" || status == "drawed" || status == 'received') {
        this.mainService.toast({ title: 'Error', body: "Award not granted for user please grant award first", type: 'danger' });
      } else {
        this.api.changeAwardStatus(award.id, status).subscribe((res: any) => {
          this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
          this.getAwards();
        }, (err) => {
          debugger;
          this.mainService.toast({ title: 'Error', body: err.data.title, type: 'danger' });
        });
      }
    } else {
      this.api.changeAwardStatus(award.id, status).subscribe((res: any) => {
        this.mainService.toast({ title: 'Success', body: res.data.title, type: 'dark' });
        this.getAwards();
      }, (err) => {
        debugger;
        this.mainService.toast({ title: 'Error', body: err.data.title, type: 'danger' });
      });
    }

  }
}
